import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Page.css';
import './Company.css';

const Company: React.FC = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  return (
    <div className="page company-page">
      <div className="page-hero" style={{ backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/company.jpg')" }}>
        <h1 className="animate-fade-up">Our Company</h1>
        <p className="hero-subtitle animate-fade-up delay-200">Innovative Accountants Auckland</p>
      </div>
      
      <div className="company-container">
        {/* Introduction Section */}
        <section className="company-intro">
          <div className="intro-content animate-fade-up delay-300">
            <h2>About Growbal</h2>
            <p className="lead-text">
              Growbal is a modern accounting firm founded by Hattie Chu in 2013, operating as a public practice under both CA ANZ and CPA Australia.
            </p>
            <p>
              Our young and diverse team is passionate about helping small to medium-sized businesses grow. No matter what stage your business is at, we provide high-quality service and practical advice to help you reach your goals.
            </p>
            <p>
              By combining cutting-edge technology with proven traditional accounting methods, we deliver real results in a way that is both convenient and cost-effective.
            </p>
          </div>
          <div className="intro-image animate-fade-up delay-500">
            <img src="/images/nortisland.jpg" alt="North Island Advisors" />
          </div>
        </section>
      </div>

      {/* Values Section - Full Width Background */}
      <div className="full-width-bg">
        <div className="values-container">
          <div className="section-header animate-fade-up">
            <h2>Our Core Values</h2>
            <p>The principles that guide everything we do at Growbal</p>
          </div>
          
          <div className="values-grid-modern">
            <div className="value-card animate-fade-up delay-100">
              <div className="value-icon">💡</div>
              <h3>Innovation</h3>
              <p>
                The team at Growbal love to challenge the norm and question the status quo. We're proud embracers of new technology 
                and continue to adopt innovative solutions. We harness the power of accounting industry changes and make them work for you.
              </p>
            </div>

            <div className="value-card animate-fade-up delay-200">
              <div className="value-icon">📚</div>
              <h3>Knowledge</h3>
              <p>
                We understand that knowledge is power. We encourage our staff to think big, ask questions and believe that simple 
                ideas are what lead to great solutions. It's this thinking that drives us to achieve such high standards.
              </p>
            </div>

            <div className="value-card animate-fade-up delay-300">
              <div className="value-icon">🤝</div>
              <h3>Honesty & Accountability</h3>
              <p>
                We're transparent in our processes because we want you to understand exactly what's happening. We're committed to upholding 
                the highest levels of integrity, honesty, and respect in our personal and professional lives.
              </p>
            </div>

            <div className="value-card animate-fade-up delay-400">
              <div className="value-icon">🌟</div>
              <h3>Culture</h3>
              <p>
                Our culture sets us apart. We embrace excellence in all that we do. Whether delivering exceptional work to our clients 
                or finding new solutions to age-old problems, we strive to provide top-notch services.
              </p>
            </div>

            <div className="value-card animate-fade-up delay-500">
              <div className="value-icon">🌱</div>
              <h3>Environmental Friendly</h3>
              <p>
                We run a paperless practice and provide support and education to our clients so they can too. Modern technology allows us 
                to streamline our business and remove those pesky piles of paperwork.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="company-container">
        {/* Culture Section */}
        <section className="company-culture">
          <div className="culture-image animate-fade-up delay-200">
            <img src="/images/business-growth.jpg" alt="Our Culture" />
          </div>
          <div className="culture-content animate-fade-up delay-400">
            <h2>Our Diverse Team</h2>
            <p>
              Our team come from all walks of life and we're proud to be a multi-cultural firm. This diversity brings a wealth of perspectives and ideas to the table, allowing us to better understand and serve our varied client base.
            </p>
            <p>
              We believe that a supportive and inclusive environment fosters creativity and excellence. When you work with Growbal, you're working with real people who care about your success as much as you do.
            </p>
          </div>
        </section>

        {/* CTA Section */}
        <section className="company-cta animate-fade-up">
          <h2>Want to grow your business?</h2>
          <p>Our Free Resources will Help</p>
          <button className="cta-button" onClick={handleContactClick}>Request a Consultation</button>
        </section>
      </div>
    </div>
  );
};

export default Company;
